'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _AboutLocalExperts = require('./AboutLocalExperts.scss');

var _AboutLocalExperts2 = _interopRequireDefault(_AboutLocalExperts);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  AboutLocalExperts: {
    displayName: 'AboutLocalExperts'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Home/AboutLocalExperts.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var AboutLocalExperts = _wrapComponent('AboutLocalExperts')((_dec = (0, _reactCssModules2.default)(_AboutLocalExperts2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AboutLocalExperts, _Component);

  function AboutLocalExperts() {
    (0, _classCallCheck3.default)(this, AboutLocalExperts);
    return (0, _possibleConstructorReturn3.default)(this, (AboutLocalExperts.__proto__ || (0, _getPrototypeOf2.default)(AboutLocalExperts)).apply(this, arguments));
  }

  (0, _createClass3.default)(AboutLocalExperts, [{
    key: 'render',
    value: function render() {
      return _react3.default.createElement(
        'div',
        { styleName: 'container-' + this.props.bgColor },
        _react3.default.createElement(
          'div',
          { styleName: 'inner' },
          _react3.default.createElement(
            _Link2.default,
            { to: '/trust-and-safety' },
            _react3.default.createElement(
              'div',
              { styleName: this.props.locale === 'th' ? 'image-th' : 'image' },
              _react3.default.createElement(
                'div',
                { styleName: 'shadow' },
                _react3.default.createElement(
                  'div',
                  { styleName: 'text-container' },
                  _react3.default.createElement(
                    'h2',
                    { styleName: 'header' },
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.about_lx.header' })
                  ),
                  _react3.default.createElement(
                    'p',
                    null,
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.about_lx.description' })
                  ),
                  _react3.default.createElement(
                    'span',
                    { styleName: 'link' },
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.about_lx.learn_more' })
                  )
                ),
                _react3.default.createElement(
                  'h2',
                  { styleName: 'mobile-header' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.about_lx.header' })
                )
              )
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'mobile-content' },
            _react3.default.createElement(
              'p',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.about_lx.description' }),
              ' ',
              _react3.default.createElement(
                _Link2.default,
                { to: '/trust-and-safety' },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.about_lx.learn_more' }),
                '.'
              )
            )
          )
        )
      );
    }
  }]);
  return AboutLocalExperts;
}(_react2.Component), _class2.propTypes = {
  locale: _react2.PropTypes.string,
  bgColor: _react2.PropTypes.string
}, _class2.defaultProps = {
  bgColor: 'white'
}, _temp)) || _class));

exports.default = AboutLocalExperts;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/AboutLocalExperts.js
// module id = 666
// module chunks = 47